<!--控制台-->
<template>
  <section class="Console-root">
    <div style="display:flex;margin-top:20px;margin-left:20px;">
      <h2 style="font-weight:800;">平台总下单金额 :</h2>
      <h2 style="font-weight:800;color:red;margin-left:10px">{{ formatMoney(yesterdayData.totalGmvAmount) }}</h2>
    </div>
    <div style="margin-left:20px;margin-top: 5px;">
      <p>{{ $utils.formatDate(new Date(),'YYYY-MM-DD') }},欢迎您来到经营驾驶仓</p>
    </div>
    <div>
      <div style="float:left;margin-left:20px;margin-top:20px;margin-bottom: 5px;">
        <h2 style="font-weight:800;">当日数据({{ $utils.formatDate(date,'YYYY年MM月DD日') }})</h2>
      </div>
      <div style="float:right">
        <!-- <span style="padding-right:10px;">日期:</span> -->
        <Date-picker type="date" transfer placeholder="选择日期" v-model="date"></Date-picker>
        <Button type="primary" style="margin-left:20px;margin-right:20px" @click="query">筛选</Button>
      </div>
    </div>
    <div style="width:970px;height:160px;border:1px solid #e8e8e8;margin-top:50px;margin-left:15px;display:flex;font-size:14px">
      <template v-for="item in listMid">
        <div style="width:242px;border-right:1px solid #e8e8e8;">
        <p style="margin-top:32px;margin-left:20px">{{ item.title }}</p>
        <p style="margin-top:5px;margin-left:20px;font-size:16px;color:red;font-weight:800;">{{ formatMoney(item.num,0) }}</p>
        <p style="margin-top:5px;margin-left:20px" class="money-line"><span style="color:#999;">累计到当日总数</span><span class="right-money" :title="formatMoney(item.total,0)">{{ formatMoney(item.total,0) }}</span></p>
        <p style="margin-left:20px" class="money-line">
          <span style="color:#999;">相比昨日</span>
          <span v-if="item.radio>0" class="right-money" :title="dealPercent(Math.abs(item.radio))" style="color:red;">{{dealPercent(Math.abs(item.radio)) }}
            <Icon class="f-arrow" type="ios-arrow-round-up" />
          </span>
          <span v-else-if="item.radio==0" class="right-money" :title="dealPercent(Math.abs(item.radio))">{{ dealPercent(Math.abs(item.radio)) }}</span>
          <span v-else class="right-money" :title="dealPercent(Math.abs(item.radio))" style="color:green;">{{ dealPercent(Math.abs(item.radio)) }}
            <Icon class="f-arrow" type="ios-arrow-round-down" />
          </span>
        </p>
      </div>
      </template>
      <!-- <div style="width:242px;border-right:1px solid #e8e8e8;">
        <p style="margin-top:32px;margin-left:20px">当日企业数</p>
        <p style="margin-top:5px;margin-left:20px;font-size:16px;color:red;font-weight:800;">{{ formatMoney(yesterdayData.platformQtyRespVo.merchants,0) }}</p>
        <p style="margin-top:5px;margin-left:20px" class="money-line"><span style="color:#999;">累计到当日总数</span><span class="right-money" :title="formatMoney(yesterdayData.platformQtyRespVo.ystMerchants)">{{ formatMoney(yesterdayData.platformQtyRespVo.ystMerchants) }}</span></p>
        <p style="margin-left:20px" class="money-line">
          <span style="color:#999;">相比昨日</span>
          <span v-if="yesterdayData.platformQtyRespVo.merchantsRadio>0" style="padding-left:60px;color:red;">{{dealPercent(Math.abs(yesterdayData.platformQtyRespVo.merchantsRadio)) }}
            <Icon class="f-arrow" type="ios-arrow-round-up" />
          </span>
          <span v-else-if="yesterdayData.platformQtyRespVo.merchantsRadio==0" class="right-money">{{ dealPercent(Math.abs(yesterdayData.platformQtyRespVo.merchantsRadio)) }}</span>
          <span v-else style="padding-left:60px;color:green;">{{ dealPercent(Math.abs(yesterdayData.platformQtyRespVo.merchantsRadio)) }}
            <Icon class="f-arrow" type="ios-arrow-round-down" />
          </span>
        </p>
      </div>
      <div style="width:243px;border-right:1px solid #e8e8e8;">
        <p style="margin-top:32px;margin-left:20px">当日商品销量</p>
        <p style="margin-top:5px;margin-left:20px;font-size:16px;color:red;font-weight:800;">{{ formatMoney(yesterdayData.platformQtyRespVo.productQty,0) }}</p>
        <p style="margin-top:5px;margin-left:20px"><span style="color:#999;">累计到当日总数</span><span class="right-money">{{ formatMoney(yesterdayData.platformQtyRespVo.ystProductQty) }}</span></p>
        <p style="margin-left:20px">
          <span style="color:#999;">相比昨日</span>
          <span v-if="yesterdayData.platformQtyRespVo.productQtyRadio>0" style="padding-left:60px;color:red;">{{dealPercent(Math.abs(yesterdayData.platformQtyRespVo.productQtyRadio)) }}
            <Icon class="f-arrow" type="ios-arrow-round-up" />
          </span>
          <span v-else-if="yesterdayData.platformQtyRespVo.productQtyRadio==0" class="right-money">{{ dealPercent(Math.abs(yesterdayData.platformQtyRespVo.productQtyRadio)) }}</span>
          <span v-else style="padding-left:60px;color:green;">{{ dealPercent(Math.abs(yesterdayData.platformQtyRespVo.productQtyRadio)) }}
            <Icon class="f-arrow" type="ios-arrow-round-down" />
          </span>
        </p>
      </div>
      <div style="width:242px;border-right:1px solid #e8e8e8;">
        <p style="margin-top:32px;margin-left:20px">当日订单数</p>
        <p style="margin-top:5px;margin-left:20px;font-size:16px;color:red;font-weight:800;">{{ formatMoney(yesterdayData.platformQtyRespVo.gmvOrders,0) }}</p>
        <p style="margin-top:5px;margin-left:20px"><span style="color:#999;">累计到当日总数</span><span class="right-money">{{ formatMoney(yesterdayData.platformQtyRespVo.ystGmvOrders) }}</span></p>
        <p style="margin-left:20px">
          <span style="color:#999;">相比昨日</span>
          <span v-if="yesterdayData.platformQtyRespVo.gmvOrdersRadio>0" style="padding-left:60px;color:red;">{{dealPercent(Math.abs(yesterdayData.platformQtyRespVo.gmvOrdersRadio)) }}
            <Icon class="f-arrow" type="ios-arrow-round-up" />
          </span>
          <span v-else-if="yesterdayData.platformQtyRespVo.gmvOrdersRadio==0" class="right-money">{{ dealPercent(Math.abs(yesterdayData.platformQtyRespVo.gmvOrdersRadio)) }}</span>
          <span v-else style="padding-left:60px;color:green;">{{ dealPercent(Math.abs(yesterdayData.platformQtyRespVo.gmvOrdersRadio)) }}
            <Icon class="f-arrow" type="ios-arrow-round-down" />
          </span>
        </p>
      </div>
      <div style="width:243px;">
        <p style="margin-top:32px;margin-left:20px">当日下单客户数</p>
        <p style="margin-top:5px;margin-left:20px;font-size:16px;color:red;font-weight:800;">{{ formatMoney(yesterdayData.platformQtyRespVo.buyerQty,0) }}</p>
        <p style="margin-top:5px;margin-left:20px"><span style="color:#999;">累计到当日总数</span><span class="right-money">{{ formatMoney(yesterdayData.platformQtyRespVo.ystBuyerQty) }}</span></p>
        <p style="margin-left:20px">
          <span style="color:#999;">相比昨日</span>
          <span v-if="yesterdayData.platformQtyRespVo.buyerQtyRadio>0" style="padding-left:60px;color:red;">{{ dealPercent(Math.abs(yesterdayData.platformQtyRespVo.buyerQtyRadio)) }}
            <Icon class="f-arrow" type="ios-arrow-round-up" />
          </span>
          <span v-else-if="yesterdayData.platformQtyRespVo.buyerQtyRadio==0" class="right-money">{{ dealPercent(Math.abs(yesterdayData.platformQtyRespVo.buyerQtyRadio)) }}</span>
          <span v-else style="padding-left:60px;color:green;">{{ dealPercent(Math.abs(yesterdayData.platformQtyRespVo.buyerQtyRadio)) }}
            <Icon class="f-arrow" type="ios-arrow-round-down" />
          </span>
        </p>
      </div> -->
    </div>
    <div style="position:relative;top:-20px;left:10px">
      <ul class="home1-ul">
        <li class="home1-li" v-for="(item,index) of list1" :key="index">
          <article>
            <h3 style="height:50px;font-size:16px;width:100%;border-bottom:1px solid #e8e8e8;line-height:50px;color:#fff;" :style="{'background':$utils.getColor(index)}">{{ item.title }}</h3>
            <p style="display:inline-block;font-size:16px;font-weight:600;width:165px;border-right:1px solid #e8e8e8;height:80px;line-height:80px">￥{{ formatMoney(item.money) }}</p>
            <p v-if='item.num>0' style="color:red;display:inline-block;width:150px"><span style="font-size:12px;color:#999;display:inline-block;position:relative;left:-20px">比昨日</span><span style="display:inline-block;position:relative;left:10px">{{ dealPercent(item.num) }}<Icon class="f-arrow" type="ios-arrow-round-up" /></span></p>
            <p v-else-if='item.num==0' style="display:inline-block;width:150px"><span style="font-size:12px;color:#999;display:inline-block;position:relative;left:-20px">比昨日</span><span style="display:inline-block;position:relative;left:10px">{{ dealPercent(item.num) }}</span></p>
            <p v-else style="color:green;display:inline-block;width:150px"><span style="font-size:12px;color:#999;display:inline-block;position:relative;left:-20px">比昨日</span><span style="display:inline-block;position:relative;left:10px">{{ dealPercent(Math.abs(item.num)) }}<Icon class="f-arrow" type="ios-arrow-round-down" /></span></p>
          </article>
        </li>
      </ul>
    </div>
    <div style="display:flex;background-color:#eee;padding-top:20px">
      <MarketingView style="width:618px;height:518px;border-radius:0">
        <template #left>企业用户分析</template>
        <template #default>
          <AppBarChart :fields="['活跃用户','新增用户']" v-model="list4" :height="400" :width="444"></AppBarChart>
        </template>
      </MarketingView>
      <MarketingView style="width:472px;height:518px;margin-left:22px;border-radius:0">
        <template #left>类目排行</template>
        <template #default>
          <div style="width:430px;height:400px;margin-left:10px">
            <div>
              <p style="display:inline-block;font-size:14px;width:204px;">类目名称</p>
              <p style="display:inline-block;font-size:14px;width:140px;">类目金额数</p>
              <p style="display:inline-block;font-size:14px;width:60px;">类目占比</p>
            </div>
            <div style="font-size:14px;margin-top:10px;">
              <ul v-if="list2.length" class="ul_1">
                <li v-for="(item,index) of list2" :key="index" style="height:35px;display:inline-flex;">
                  <span class="li_p">{{index+1}}</span>
                  <span style="margin-left:10px;width:176px;" class="f-ellipsis">{{item.cateName}}</span>
                  <p style="font-size:14px;width:140px;" class="f-ellipsis">{{formatMoney(item.tranAmount)}}</p>
                  <p style="font-size:14px;width:60px;font-weight:600;" class="f-ellipsis">{{ item.tranAmountRate }}%</p>
                </li>
              </ul>
              <AppNoData v-else :height="360"></AppNoData>
            </div>
          </div>
        </template>
      </MarketingView>
    </div>
  </section>
</template>
<script>
  import MarketingView from '@/components/MarketingView';
  export default {
    name       : 'Console',
    components : {MarketingView},
    props      : {},
    data(){
      return {
        list1         : [
          {
            title : '下单总额',
            money : '8888888.88',
            color : 'g',
            num   : '0.88',
          },
          {
            title : '成交总额',
            money : '8888888.88',
            color : 'g',
            num   : '0.88',
          },
          {
            title : '退单总额',
            money : '8888888.88',
            color : 'r',
            num   : '0.88',
          },
          {
            title : '仓库入库总额',
            money : '8888888.88',
            color : 'g',
            num   : '0.88',
          },
          {
            title : '仓库出库总额',
            money : '8888888.88',
            color : 'g',
            num   : '0.88',
          },
          {
            title : '库存总价值',
            money : '8888888.88',
            color : 'r',
            num   : '0.88',
          },
        ],
        list2         : [],
        list4         : [],
        listMid       : [],
        date          : new Date(Date.now() - 8.64e7),
        yesterdayData : {
          'platformAmountRespVo' : {
            'cancelAmount'      : 0,
            'cancelAmountRadio' : 0,
            'gmvAmount'         : 0,
            'gmvAmountRadio'    : 0,
            'tranAmount'        : 0,
            'tranAmountRadio'   : 0,
          },
          'platformQtyRespVo'    : {
            'buyerQty'        : 0,
            'buyerQtyRadio'   : 0,
            'gmvOrders'       : 0,
            'gmvOrdersRadio'  : 0,
            'merchants'       : 0,
            'merchantsRadio'  : 0,
            'productQty'      : 0,
            'productQtyRadio' : 0,
            'ystBuyerQty'     : 0,
            'ystGmvOrders'    : 0,
            'ystMerchants'    : 0,
            'ystProductQty'   : 0,
          },
          'totalGmvAmount'       : 0,
          'wmsAmountRespVo'      : {
            'inStockAmount'       : 0,
            'inStockAmountRadio'  : 0,
            'outStockAmount'      : 0,
            'outStockAmountRadio' : 0,
            'stockValue'          : 0,
            'stockValueRadio'     : 0,
          },
        },
      };
    },
    computed   : {
      params(){
        return {
          date : this.date ? this.$utils.formatDate(this.date, 'YYYY-MM-DD') : '',
        };
      },
    },
    created(){},
    mounted(){
      this.init();
    },
    methods    : {
      init(){
        this.getData();
        this.userAnalysis();
        this.getTop10Buyer();
      },
      query(){
        const requests = [
          this.getData(),
          this.getTop10Buyer(),
        ];
        Promise.all(requests).then(() => {
          this.$Message.success('刷新成功');
        });
      },
      // 格式化金额
      formatMoney(val,n){
        return this.$utils.formatMoney(val,n);
      },
      dealPercent(val){
        return `${val}%`;
      },
      // 仪表台
      getData(){
        this.$api.post('/api/v1/business/instrumentDesk/yesterdayData', this.params).then((res) => {
          const data = this.$utils.optimizeNull(res.data, this.$options.data.call(this).yesterdayData);
          this.yesterdayData = data;
          this.list1 = [
            {
              title : '下单总额',
              money : data.platformAmountRespVo.gmvAmount,
              num   : data.platformAmountRespVo.gmvAmountRadio,
            },
            {
              title : '成交总额',
              money : data.platformAmountRespVo.tranAmount,
              num   : data.platformAmountRespVo.tranAmountRadio,
            },
            {
              title : '退单总额',
              money : data.platformAmountRespVo.cancelAmount,
              num   : data.platformAmountRespVo.cancelAmountRadio,
            },
            {
              title : '仓库入库总额',
              money : data.wmsAmountRespVo.inStockAmount,
              num   : data.wmsAmountRespVo.inStockAmountRadio,
            },
            {
              title : '仓库出库总额',
              money : data.wmsAmountRespVo.outStockAmount,
              num   : data.wmsAmountRespVo.outStockAmountRadio,
            },
            {
              title : '库存总价值',
              money : data.wmsAmountRespVo.stockValue,
              num   : data.wmsAmountRespVo.stockValueRadio,
            },
          ];

          this.listMid = [
            {
              title : '当日企业数',
              radio : data.platformQtyRespVo.merchantsRadio,
              num   : data.platformQtyRespVo.merchants,
              total : data.platformQtyRespVo.ystMerchants
            },
            {
              title : '当日商品销量',
              radio : data.platformQtyRespVo.productQtyRadio,
              num   : data.platformQtyRespVo.productQty,
              total : data.platformQtyRespVo.ystProductQty
            },
            {
              title : '当日订单数',
              radio : data.platformQtyRespVo.gmvOrdersRadio,
              num   : data.platformQtyRespVo.gmvOrders,
              total : data.platformQtyRespVo.ystGmvOrders
            },
            {
              title : '当日下单客户数',
              radio : data.platformQtyRespVo.buyerQtyRadio,
              num   : data.platformQtyRespVo.buyerQty,
              total : data.platformQtyRespVo.ystBuyerQty
            }
          ]
        });
      },
      // 企业用户分析
      userAnalysis(){
        this.$api.post('/api/v1/business/instrumentDesk/userAnalysis').then((res) => {
          this.list4 = res.data.map((v, i) => {
            return {
              key    : v.month + '-' + v.day,
              '活跃用户' : v.activeUser,
              '新增用户' : v.newUser,
            };
          });
        });
      },
      // 本周行业排行
      getTop10Buyer(){
        this.$api.post('/api/v1/business/instrumentDesk/getTop10Buyer', this.params).then((res) => {
          this.list2 = res.data;
        });
      },
    },
  };
</script>
<style scoped lang="scss">
  .Console-root{
    .money-line{display: flex;align-items: center;justify-content: space-between;padding-right: 20px;}
    .right-money{
      width: 100px;
      display: inline-block;
      padding-left: 10px;
      text-align: right;
      @extend %ellipsis;
    }
  }
  .home1{
    &-ul{display: flex;flex-wrap: wrap;}
    &-li{ $w: 320px;
      height: 130px;
      margin-top: 30px;overflow: hidden;width: $w;background: #fff;border: 1px solid $light-bd-color;
      border-radius: 6px;
      margin-left: 5px;
      text-align: center;
    }
  }
  .li_p{
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 5px;
    line-height: 18px;
    text-align: center;
  }
  .ul_1{
    li{
      .li_p{background: #dceeff;color: #2f97ff;}
      &:nth-child(1) .li_p{background: #1890ff;color: #fff}
      &:nth-child(2) .li_p{background: #f39800;color: #fff}
      &:nth-child(3) .li_p{background: #fb4058;color: #fff}
    }
  }
</style>
